import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { humanize } from 'underscore.string';
import Alert from 'components/ui/Alert';

import { FormGroup } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
import stopIntentTypes from 'config/stop-intent-types';
import Location from 'components/modules/booking/Location';
import LocationContact from 'components/modules/booking/LocationContact';

import { getLocationUpdates } from 'components/modules/booking/BookingHelper';
import Checkbox from '../../../v2/forms/Checkbox';

function mapPropsToState(props) {
  const stop = props.stop || {};
  const { action, empty } = stop;
  const locations = stop.location || [];

  const location = locations[0] || {};

  const contacts = stop.contacts || [];
  const contact = contacts[0] || {};
  const off_site = stop.off_site || false;
  const { name, address, lat, lng, suite_or_apt } = location;

  return {
    error: {},
    action: action,
    empty: empty || false,
    location: {
      name,
      address: {
        label: address,
      },
      lat,
      lng,
      suite_or_apt,
    },
    contact,
    off_site,
  };
}

class LocationModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    stop: PropTypes.shape({
      sequence: PropTypes.number,
      action: PropTypes.string,
      empty: PropTypes.bool,
      location: PropTypes.arrayOf(
        PropTypes.shape({
          address: PropTypes.string,
          lat: PropTypes.number,
          lng: PropTypes.number,
          suite_or_apt: PropTypes.string,
        }),
      ),
      contact: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          phone: PropTypes.string,
        }),
      ),
      off_site: PropTypes.bool,
    }).isRequired,
    shipment: PropTypes.shape({
      stops: PropTypes.arrayOf(
        PropTypes.shape({
          action: PropTypes.string,
          sequence: PropTypes.number,
        }),
      ),
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {
    show: false,
  };

  constructor(props) {
    super(props);
    this.state = mapPropsToState(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.setState(mapPropsToState(nextProps));
    }
  }

  getValidationState(key) {
    const { error } = this.state;
    if (Object.prototype.hasOwnProperty.call(error, key)) {
      return 'error';
    }
    return null;
  }

  getContact() {
    return this.state.contact;
  }

  handleActionChange = (e) => {
    const slug = e.target.value;
    let action = slug;
    let empty = true;

    switch (slug) {
      case 'pickup_empty':
        action = 'pickup';
        break;
      case 'deliver_empty':
        action = 'deliver';
        break;
      default:
        empty = false;
    }

    this.setState({ action, empty });
  };

  handleLocationFieldChange = (field, value) => {
    this.setState((prevState) => {
      return {
        location: {
          ...prevState.location,
          [field]: value,
        },
      };
    });
  };
  // Locations
  handleLocationNameSelect = (selectedLocation) => {
    const location = getLocationUpdates(selectedLocation);

    this.setState({ location });
  };

  handleLocationAddressSelect = (item) => {
    const { label, location } = item;
    const { lat, lng, place_id } = location;
    const coords = [lng, lat];

    this.setState((prevState) => {
      return {
        location: {
          ...prevState.location,
          address: {
            label,
            location,
          },
          coords,
          lat,
          lng,
          place_id,
        },
      };
    });
  };

  handleLocationContactChange = (attribute, value) => {
    this.setState((prevState) => {
      return {
        contact: {
          ...prevState.contact,
          [attribute]: value,
        },
      };
    });
  };

  handleOffSiteChange = (off_site) => {
    this.setState({
      off_site,
    });
  };

  handleSaveClick = () => {
    const error = this.validate();

    if (Object.keys(error).length === 0) {
      const {
        location: {
          address: { label: address },
          name,
          suite_or_apt,
          lat,
          lng,
          place_id,
        },
        contact,
        off_site,
      } = this.state;

      const changes = {
        action: this.state.action,
        empty: this.state.empty,
        location: {
          address,
          name,
          suite_or_apt,
          lat,
          lng,
          place_id,
        },
        contacts: [contact],
        off_site,
      };

      this.props.onSave(this.props.stop, changes);
    } else {
      this.setState({ error });
    }
  };

  validate() {
    const error = {};
    const { t } = this.props;
    const {
      action,
      location: { name, address },
      contact: { phone },
    } = this.state;

    if (!action) {
      error.action = t('INTENT_IS_REQUIRED_ERROR');
    } else {
      const { stop } = this.props;
      const {
        shipment: { stops },
      } = this.props;
      const otheractions = stops
        .filter((s) => s.sequence !== stop.sequence)
        .map((s) => s.action);
      const actions = [...otheractions, action];
      if (!actions.includes('pickup') || !actions.includes('deliver')) {
        error.action = t('MINIMUM_STOP_ERROR');
      }
    }

    if (!name) {
      error.name = t('LOCATION_IS_REQUIRED_ERROR');
    }

    if (!address || !address.label) {
      error.address = t('ADDRESS_FROM_LIST_ERROR');
    }

    if (phone && phone !== '' && phone.length < 10) {
      error.contact = t('VALID_PHONE_NUMBER_ERROR');
    }

    return error;
  }

  renderIntentDropdown() {
    const { t } = this.props;
    const { action, empty } = this.state;

    const foo = (slug) => {
      if (empty) {
        const expected = `${action}_empty`;
        if (slug === expected) return true;
      } else if (!empty && slug === action) return true;
      return false;
    };

    return (
      <FormGroup validationState={this.getValidationState('action')}>
        <select
          onChange={this.handleActionChange}
          value={action}
          className="form-select"
        >
          <option value="">{t('SELECT_INTENT')}</option>
          {stopIntentTypes.map((item) => (
            <option selected={foo(item.slug)} key={item.slug} value={item.slug}>
              {t(item.localizationSlug)}
            </option>
          ))}
        </select>
      </FormGroup>
    );
  }

  renderErrors() {
    const { error } = this.state;
    const errorKeys = Object.keys(error);
    const hasErrors = errorKeys.length > 0;

    if (hasErrors) {
      return (
        <Alert type="error" className="mb-4">
          <ul>
            {errorKeys.map((key) => (
              <li key={key}>{error[key]}</li>
            ))}
          </ul>
        </Alert>
      );
    }
    return null;
  }
  renderBody() {
    const { t } = this.props;
    const { action, location } = this.state;

    const label = humanize(action);
    const contact = this.getContact();
    return (
      <fieldset>
        <div className="grid grid-cols-4 gap-4">
          <div className="col-span-1">
            <div>
              <label className="mb-1 form-label">{t('SELECT_INTENT')}</label>
              {this.renderIntentDropdown()}
            </div>
            <Checkbox
              checked={this.state.off_site}
              onChange={this.handleOffSiteChange}
              id="offsite"
            >
              {t('IS_OFFSITE')}
            </Checkbox>
          </div>
          <div className="col-span-3">
            <Location
              label={label}
              onChange={this.handleLocationFieldChange}
              onNameSelect={this.handleLocationNameSelect}
              onAddressSelect={this.handleLocationAddressSelect}
              location={location}
            />
            <LocationContact
              contact={contact}
              onContactChange={this.handleLocationContactChange}
            />
          </div>
        </div>
      </fieldset>
    );
  }
  renderFooter() {
    const { t } = this.props;
    return (
      <div className="flex justify-end space-x-2">
        <button className="button button-green" onClick={this.handleSaveClick}>
          {t('SAVE')}
        </button>
        <button
          className="button button-secondary"
          onClick={() => this.props.onClose()}
        >
          {t('CLOSE')}
        </button>
      </div>
    );
  }
  render() {
    const { t } = this.props;
    const stop = this.props.stop || {};
    const { sequence } = stop;
    let title;

    if (sequence) {
      title = t('EDIT_INTENT_WITH_SEQUENCE_TITLE', { sequence });
    } else {
      title = t('EDIT_INTENT_TITLE');
    }

    const body = this.props.show ? this.renderBody() : null;
    return (
      <CargomaticModal
        show={this.props.show}
        title={title}
        footer={this.renderFooter()}
      >
        {this.renderErrors()}
        {body}
      </CargomaticModal>
    );
  }
}

export default withTranslation()(LocationModal);
